import { Url } from '@wix/da-url';
import { ModalOptions, ModalType } from '../Modals/redux/types';
import { VerificationRequiredActions } from '../publicSession/types';

const submitMenuItems: {
  type: string;
  label: string;
  link?: () => string;
  target?: string;
  modalType?: ModalType;
  modalOptions?: ModalOptions;
  imageFileName?: string;
  imageMarginBottom?: number;
  imageMarginLeft?: number;
  verificationAction?: VerificationRequiredActions;
  isNew?: boolean;
  showDaProtect?: boolean;
  showNewByTitle?: boolean;
  openInStudio?: boolean;
  feature?: string;
}[] = [
  {
    type: 'deviation',
    label: 'siteHeader.deviation',
    imageFileName: 'deviation-2x.png', // IL6.2
    imageMarginBottom: 10,
    link: () => Url.studio({ openSubmitForm: true }),
    modalType: ModalType.DEVIATION_SUBMIT,
    openInStudio: true,
  },
  {
    type: 'status',
    label: 'siteHeader.statusUpdate',
    verificationAction: 'submitstatus',
    modalType: ModalType.STATUS_UPDATE,
    imageFileName: 'status-update-2x.png', // IL6.8
    imageMarginBottom: 20,
    imageMarginLeft: 30,
  },
  {
    type: 'journal',
    label: 'siteHeader.journal',
    verificationAction: 'submitjournal',
    modalType: ModalType.JOURNAL,
    imageFileName: 'journal-2x.png', // IL6.3
    imageMarginBottom: 32,
  },
  {
    type: 'literature',
    label: 'siteHeader.literature',
    modalType: ModalType.LITERATURE,
    imageFileName: 'literature-2x.png', // IL6.4
    imageMarginBottom: 32,
  },
  {
    type: 'commission',
    label: 'siteHeader.commission',
    verificationAction: 'submitcommission',
    modalType: ModalType.COMMISSION,
    modalOptions: {
      params: { redirectOnSubmit: true },
    },
    imageFileName: 'commission-2x.png', // IL6.1
    imageMarginBottom: 32,
  },
  {
    type: 'poll',
    label: 'siteHeader.poll',
    verificationAction: 'submitpoll',
    modalType: ModalType.POLL_EDIT,
    imageFileName: 'poll-2x.png', // IL6.7
    imageMarginBottom: 32,
  },
  {
    type: 'tier',
    label: 'siteHeader.tier',
    modalType: ModalType.TIER_EDIT,
    modalOptions: {
      wrapInModal: false,
    },
    isNew: true,
    imageFileName: 'subscription-2x.png', // IL6.9
    imageMarginBottom: 32,
  },
  {
    type: 'dreamup',
    label: 'siteHeader.dreamup',
    link: () => Url.dreamupLink(),
    isNew: true,
    imageFileName: 'dreamup-2x.png', // IL6.10
    imageMarginBottom: 32,
  },
];

export const desktopSubmitMenuItems = [
  'deviation',
  'dreamup',
  'status',
  'journal',
  'literature',
  'tier',
].map(type => submitMenuItems.find(item => item.type === type)!);

// mobile has fewer items in different order
export const mobileSubmitMenuItems = ['deviation', 'dreamup', 'status'].map(
  type => submitMenuItems.find(item => item.type === type)!
);

export const submitButtonMenuItem = {
  type: 'submitbutton',
  link: Url.studio({ openSubmitForm: true }),
  modalType: ModalType.DEVIATION_SUBMIT,
  openInStudio: true,
};
